/* eslint-disable */

//AI智能英语 https 生产环境 226
function liXiao_226_https() {
    return {
        brand: "LIXIAO",                         //品牌
        hostname: '127.0.0.1',                   //域名
        API_ADDRESS: "https://lx-prod-api.yingyutifen.cn:6443",      //服务器地址
        WSS_ADDRESS: "wss://lx-prod-api.yingyutifen.cn:6443/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "https://print.yingyutifen.cn",       //服务器地址
    }
}

//AI智能英语 直属  215
function liXiao_head_215_https() {
    return {
        brand: "LIXIAO",                         //品牌
        hostname: '127.0.0.1',                   //域名
        API_ADDRESS: "https://lx-prod-head-api.yingyutifen.cn",      //服务器地址
        WSS_ADDRESS: "wss://lx-prod-head-api.yingyutifen.cn/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "https://print.yingyutifen.cn",       //服务器地址
    }
}

//AI智能英语 226
function liXiao_226_pre() {
    return {
        brand: "LIXIAO",               //品牌
        hostname: '127.0.0.1',         //域名
        API_ADDRESS: "http://116.62.194.226:24710",       //服务器地址
        WSS_ADDRESS: "ws://116.62.194.226:24710/myWs",    //websocket服务器地址
        PRINT_ADDRESS: "https://print.yingyutifen.cn",    //服务器地址
    }
}

//本地服务器
function local() {
    return {
        brand: "YXW",                         //品牌
        hostname: '127.0.0.1',              //域名
        API_ADDRESS: "http://127.0.0.1:60314",            //服务器地址
        WSS_ADDRESS: "ws://127.0.0.1:60314/myWs",         //websocket服务器地址
        PRINT_ADDRESS: "http://47.110.141.208:23130",    //服务器地址
    }
}

//本地服务器
function local_zgq() {
    return {
        brand: "YXW",                         //品牌
        hostname: '127.0.0.1',               //域名
        API_ADDRESS: "http://127.0.0.1:60315",            //服务器地址
        WSS_ADDRESS: "ws://127.0.0.1:60315/myWs",         //websocket服务器地址
        PRINT_ADDRESS: "http://47.110.141.208:23130",    //服务器地址
    }
}

function localCompany() {
    return {
        brand: "YES",                         //品牌
        hostname: '127.0.0.1',              //域名
        API_ADDRESS: "http://192.168.2.8:60314",            //服务器地址
        WSS_ADDRESS: "ws://192.168.2.8:60314/myWs",         //websocket服务器地址
        PRINT_ADDRESS: "http://47.110.141.208:23130",    //服务器地址
    }
}

//AI智能英语 3.0 test ip + port
function lx3_test() {
    return {
        brand: "LIXIAO",                         //品牌
        hostname: '47.96.254.137',
        API_ADDRESS: "http://47.96.254.137:60316",       //服务器地址
        WSS_ADDRESS: "ws://47.96.254.137:60316//myWs",    //websocket服务器地址
        PRINT_ADDRESS: "http://47.96.254.137:23132",     //服务器地址
    }
}

//耶思https
function yesHttps() {
    return {
        brand: "YES",                         //品牌
        hostname: '120.79.206.195',              //域名
        API_ADDRESS: "https://api.edu-yes.cn",      //服务器地址
        WSS_ADDRESS: "wss://api.edu-yes.cn/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "https://print.edu-yes.cn",       //服务器地址
    }
}

//耶思
function yes_pre() {
    return {
        brand: "YES",                         //品牌
        hostname: '120.79.206.195',              //域名
        API_ADDRESS: "http://120.79.206.195:60316",       //服务器地址
        WSS_ADDRESS: "ws://120.79.206.195:60316/myWs",    //websocket服务器地址
        PRINT_ADDRESS: "https://print.edu-yes.cn",     //服务器地址
    }
}
//AI智能英语 https 生产环境 226
function lx3_slb_https() {
    return {
        brand: "LIXIAO",                         //品牌
        hostname: '127.0.0.1',                   //域名
        API_ADDRESS: "https://lx3-api.yingyutifen.cn",      //服务器地址
        WSS_ADDRESS: "wss://lx3-api.yingyutifen.cn/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "https://print.yingyutifen.cn",       //服务器地址
    }
}

function lx3_slbtest_https() {
    return {
        brand: "LIXIAO",                         //品牌
        hostname: '127.0.0.1',                   //域名
        VERIFY_ADDRESS: "http://47.110.141.208:60315",    //登录图形验证
        API_ADDRESS: "http://47.110.141.208:61300",       //服务器地址
        WSS_ADDRESS: "ws://47.110.141.208:61300/myWs",    //websocket服务器地址
        PRINT_ADDRESS: "http://47.110.141.208:23130",     //服务器地址
    }
}
//AI智能英语 https 生产环境 226
function yxw3_slb_https() {
    return {
        brand: "YXW",                         //品牌
        hostname: '127.0.0.1',                   //域名
        API_ADDRESS: "https://yxw3-api.yingxiaowu.cn",      //服务器地址
        WSS_ADDRESS: "wss://yxw3-api.yingxiaowu.cn/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "http://yxw6-print.yingxiaowu.cn",       //服务器地址
    }
}
function ydl_https() {
    return {
        brand: "YXW",                         //品牌
        hostname: '127.0.0.1',                   //域名
        API_ADDRESS: "https://test.api.yidianling.tech:9443",      //服务器地址
        WSS_ADDRESS: "wss://test.api.yidianling.tech:9443/myWs",   //websocket服务器地址
        PRINT_ADDRESS: "https://test.print.yidianling.tech:9443/",       //服务器地址
    }
}
// local
// lx3_test
// liXiao_226_pre
// liXiao_226_https
// lx3_slb_https
//

const userAgent = navigator.userAgent;
/**
 * 判断当前设备是否是平板设备（iPad 或 Android 平板）
 * @returns {boolean} 如果是平板设备返回 true，否则返回 false
 */
function isTabletDevice() {
    const userAgent = navigator.userAgent;
    console.log(userAgent);
    return /iPad|Android/i.test(userAgent) && !/Mobile/i.test(userAgent);
}
/**
 * 判断当前设备是否是移动设备（手机或平板）
 * @returns {boolean} 如果是移动设备返回 true，否则返回 false
 */
function isMobileDevice() {
    const userAgent = navigator.userAgent;
    return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
}
function getDomainName() {
    let Domain= location.hostname;
    if(isMobileDevice()||isTabletDevice())
    {
        if(Domain.includes('localhost'))
        {
        Domain=process.env.VUE_APP_HOSTNAME;
        }
    }
    return Domain;
}
export default {
    version:  process.env.VUE_APP_VERSION, //APP版本
    //config:lx3_slb_https(), //分布式版本lx3_slb_https
    //config:liXiao_226_https(),
    config:{
        brand: process.env.VUE_APP_BRAND,                         //品牌
        hostname: getDomainName(),                   //域名
        API_ADDRESS: process.env.VUE_APP_API_ADDRESS,      //服务器地址
        WSS_ADDRESS: process.env.VUE_APP_WSS_ADDRESS,   //websocket服务器地址
        PRINT_ADDRESS: process.env.VUE_APP_PRINT_ADDRESS,       //服务器地址
    }
}
